import { PdfTemplate } from "components"
import moment from "moment"
import { PropsWithChildren } from "react"
import { cellValuePdf, RowExportTypePdf } from "types"
import { APPROVAL, convertNumber } from "utils"
import { ApproveType } from "../types"

type ExportPDFBuildApprovalType = { data: ApproveType[] }
export const ExportPDFBuildApproval = (props: PropsWithChildren<ExportPDFBuildApprovalType>) => {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "BUILD ID#", key: "trx_code", width: 20 },
    { header: "DATE", key: "transaction_date", width: 20 },
    { header: "DESCRIPTION", key: "product_name", width: 30 },
    { header: "QTY BUILD", key: "qty_build_unit", width: 15 },
    { header: "UNIT", key: "mr_unit_name", width: 20 },
    { header: "LOCATION", key: "location_name", width: 20 },
    { header: "STATUS APPROVE", key: "approve_status", width: 20 },
    { header: "DATE APPROVE", key: "approve_date", width: 20 }
  ]

  const dataMap: RowExportTypePdf[] = props.data.map((item, index) => {
    return {
      no: index + 1,
      trx_code: item.trx_code,
      transaction_date: moment(item.transaction_date).format("DD/MM/YYYY"),
      product_name: item.product_name,
      qty_build_unit: numberFormat(item.qty_build_unit),
      mr_unit_name: item.mr_unit_name,
      location_name: item.location_name,
      approve_status: APPROVAL[item.approve_status],
      approve_date: moment(item.approve_date).format("DD/MM/YYYY")
    }
  })

  return (
    <PdfTemplate
      data={dataMap} 
      module="INVENTORY" 
      title="TRANSACTION BUILD APPROVAL" 
      column={columns}
    />
  )
}
const numberFormat = (value: number): cellValuePdf => {
  return {
    text: convertNumber(value).intoCurrency,
    style: {
      textAlign: "right",
      fontWeight: "bold"
    }
  }
}